export default __webpack_public_path__ + "static/media/copy.e8a98eac.svg";